import React from 'react';
import styles from './style.module.scss';

type PulsateProps = {
  width: string;
  height: string;
  marginBottom?: string;
  marginTop?: string;
};

const Pulsate: React.FC<PulsateProps> = ({ width = '10%', height = '10%', marginBottom = '8px', marginTop }) => {
  return (
    <div
      className={styles['pulsate']}
      style={{
        width,
        height,
        marginBottom,
        marginTop,
      }}
    />
  );
};

export default Pulsate;
